import moment from 'moment';

export function nSamplesInGroups(sampleGroups, platform) {
  let filtered = sampleGroups;
  if (platform) {
    filtered = filtered.filter(sampleGroup => sampleGroup.sequencing_platform === platform);
  }
  return filtered.reduce((acc, sample) => acc + sample.n_samples, 0);
}

export function nSamplesInRuns(runs, platform) {
  return runs.reduce((acc, run) => acc + nSamplesInGroups(run.samples, platform), 0);
}

/**
 * Returns an array of current runs.
 *
 * A current run is one whose planned_end has not passed the current date.
 *
 * If excludeUnscheduled is set (it is by default), the runs with no
 * planned_end are also excluded.
 */
export function filterCurrentRuns(runs, excludeUnscheduled = true) {
  const now = new Date();
  if (!excludeUnscheduled) {
    return runs.filter(r =>
      (r.planned_end && (moment(r.planned_end) > now)) || !r.planned_end);
  }
  return runs.filter(r => r.planned_end && (moment(r.planned_end) > now));
}
